import styled from 'styled-components';
import Button from '../../Button';
import { FlexColumn } from '../../Flex';
import { Suggestion } from '../types';

const Wrapper = styled(FlexColumn)<{ $maxWidth?: number }>`
  width: 100%;
  align-self: center;
  gap: 8px;
  align-items: center;
  padding: 24px 24px 16px;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}px` : 'none')};
`;

const SuggestionButton = styled(Button)`
  max-width: 100%;
  min-width: 0;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
  color: ${({ theme }) => theme.palette.common.gray2};
`;

const ButtonText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const NewTag = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1px 6px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.4px;
  background: ${({ theme }) => theme.palette.common.lightMagenta};
  color: ${({ theme }) => theme.palette.common.magenta};
  margin-left: 8px;
  flex-shrink: 0;
`;

type Props = {
  suggestions: Suggestion[];
  onClick: (value: string) => void;
  maxWidth?: number;
  disabled?: boolean;
};

const normalize = (item: Suggestion): { label: string; isNew: boolean } =>
  typeof item === 'string'
    ? { label: item, isNew: false }
    : { label: item.label, isNew: !!item.isNew };

const SuggestionSection = ({
  suggestions,
  onClick,
  maxWidth,
  disabled,
}: Props) => {
  if (!suggestions.length) return null;

  return (
    <Wrapper $maxWidth={maxWidth}>
      {suggestions.map((item) => {
        const { label, isNew } = normalize(item);
        return (
          <SuggestionButton
            key={label}
            variant="outlined"
            disabled={disabled}
            onClick={() => onClick(label)}
          >
            <ButtonText>{label}</ButtonText>
            {isNew && <NewTag>NEW</NewTag>}
          </SuggestionButton>
        );
      })}
    </Wrapper>
  );
};

export default SuggestionSection;
